// extracted by mini-css-extract-plugin
module.exports = {"ProseMirror":"NewsListItem_ProseMirror__3E84w","item":"NewsListItem_item__32ajx","item__title":"NewsListItem_item__title__XZjql"};